import { Dialog, DialogTitle, DialogContent, Typography, Box } from '@mui/material';
import OrderList from './OrderList';
import { ORDER_STATUS } from 'consts';

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function UnconfirmedOrdersDialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Órdenes pendientes de acción</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 12, fontWeight: 600, opacity: 0.9 }}>
          Por favor chequea el estado de estas órdenes y confirma si fueron recogidas o no
        </Typography>
        <Box display='flex' justifyContent='center'>
          <OrderList title='' statuses={[ORDER_STATUS.NOT_CONFIRMED]} daysBack={30} fullWidth />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
